<app-item [class.rounded-border-box]="showBorderBox" columnar (click)="controlClicked()">
	@if (label && !hideLabel) {
		<div>
			<app-item-label class="validation-label">{{label}}</app-item-label>
			<ng-content></ng-content>
		</div>
	}
    @if (readOnly) {
		@if (value || alwaysDisplayValue) {
        	<app-item-value [value]="value" multiLine></app-item-value>
		}
    }
    @else {
        <app-item-textarea [placeholder]="placeholder" [value]="value" [minRows]="minRows" [debounce]="debounceDuration" [emitOnInput]="emitOnInput" (keydown)="onKeydown($event)" (valueChange)="valueChanged($event)" (itemFocus)="itemFocused()"></app-item-textarea>
    }
</app-item>